import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as Account from '../../../my-account/actions/account.actions';
import * as fromCore from '../../../core/reducers';
import * as fromAuth from '../../../auth/reducers';

// Services
import { TranslationService } from '../../../translation/services/translation.service';

@Component({
  selector: 'terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrls: ['./terms-modal.component.scss']
})
export class TermsModalComponent implements OnInit {

  // Should show
  @Input() show: boolean = false;

  // Public variables
  public langPickerOpened: boolean = false;
  public currentTermsLang;

  // Observables
  public terms$: Observable<string> = this.coreStore.select(state => state.core.account.terms);

  // Construcotr
  constructor(
    private router: Router,
    private coreStore: Store<fromCore.State>,
    private translationService: TranslationService
  ) { }

  // On component init
  ngOnInit() {
    // Getting license language by default (English)
    this.currentTermsLang = this.translationService.langsAvailable[0];
  }

  // Get languages availables
  public get languagesAvailable(): Array<any> {
    return this.translationService.langsAvailable;
  }

  // Toggle license agreement modal
  public toggleTermsModal(): void {
    this.coreStore.dispatch(new Account.ToggleTermsModal());
  }

  // Toggle lang picker dropdown
  public toggleLangPicker(): void {
    this.langPickerOpened = !this.langPickerOpened;
  }

  // Change license language
  public changeTermsLang(lang): void {
    // Toggle lang picker
    this.toggleLangPicker();
    // Save new lang
    this.currentTermsLang = lang;
    // Get the new license
    this.coreStore.dispatch(new Account.GetTerms(this.currentTermsLang.code));
  }
  public scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/terms-modal/terms-modal.component.ts